import { Provider } from '@angular/core';
import { CUSTOM_ACTION_BAR_REPORT_LAUNCHER } from '../../../shared/services/custom-action-bar-report-launcher';
import { CustomActionBarReportLauncherService } from '../services/custom-action-bar-report-launcher.service';

export const CUSTOM_ACTION_BAR_REPORT_LAUNCHER_PROVIDERS: Provider[] = [
    {
        provide: CUSTOM_ACTION_BAR_REPORT_LAUNCHER,
        useExisting: CustomActionBarReportLauncherService,
    },
];
